import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { actions } from 'builder/modules/panel'
import { actions as userActions } from 'builder/modules/user'
import { useUser } from 'builder/hooks/useUser'

type ReturnType = {
  handleOpen90DaysPage: () => void
  handleOpenBookCoach: () => void
}

export const useFirst90DaysPlanActions = (): ReturnType => {
  const user = useUser()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleOpen90DaysPage = () => {
    if (!user?.uiStates?.first90DaysPlanSeen) {
      dispatch(actions.setUIStatesConfigStatus({ first_90_days_seen: true }))
      dispatch(userActions.setUIUserState({ first90DaysPlanSeen: true }))
    }
    navigate('/career-plans/first-90-days')
  }

  const handleOpenBookCoach = () => {
    navigate('/career-coaching')
  }

  return {
    handleOpen90DaysPage,
    handleOpenBookCoach,
  }
}
